// Wrap social links photographer profile
jQuery(
	'.woocommerce-products-header .wcpv-vendor-profile, .woocommerce-products-header .wcpv-vendor-profile-link, .woocommerce-products-header .wcpv-vendor-profile-social '
).wrapAll("<div class='wcpv-vendor-profile-link-social-wrapper' />");

// Insert Masonry sizer after product grid
//jQuery("<li id='grid-size'></li><li id='gutter-size'></li>").prependTo('.products');

// Wrap tools for product listings
jQuery('.products li.product .button').addClass('product-tool');

var divs = jQuery('.product-tool');
for (var i = 0; i < divs.length; i += 3) {
	divs.slice(i, i + 3).wrapAll("<div class='product-tools'></div>");
}

var divs = jQuery('.woocommerce-loop-product__title, .wcpv-sold-by-loop');
for (var i = 0; i < divs.length; i += 2) {
	divs.slice(i, i + 2).wrapAll("<div class='product-name'></div>");
}

var divs = jQuery('.products .product-name, .products .product-tools');
for (var i = 0; i < divs.length; i += 2) {
	divs.slice(i, i + 2).wrapAll("<div class='product-info'></div>");
}

// Replace text on checkout page
jQuery('.woocommerce-cart-form thead .product-name').replaceWith("<th class='product-name'>Title</th>");
jQuery('.woocommerce-cart-form thead .product-thumbnail').replaceWith("<th class='product-thumbnail'>Image</th>");

// jQuery(document).ready(function($) {
// 	$('.wp-post-image').hover(
// 		function() {
// 			$(this).find('.product-info').fadeIn(300);
// 		},
// 		function() {
// 			$(this).find('.product-info').fadeOut(100);
// 		}
// 	);
// });

// jQuery(document).ready(function($) {
// 	$('.test').hover(
// 		function() {
// 			$(this).find('.img-title').fadeIn(300);
// 		},
// 		function() {
// 			$(this).find('.img-title').fadeOut(100);
// 		}
// 	);
// });

// jQuery('.product img').hover(
// 	function() {
// 		jQuery(this).addClass('hover');
// 	},
// 	function() {
// 		jQuery(this).removeClass('hover');
// 	}
// );

// Replace dewfault Woo thumb preview link A with DIV

jQuery('.woocommerce-LoopProduct-link')
	.wrap('<div class="woocommerce-LoopProduct-link woocommerce-loop-product__link" />')
	.contents()
	.unwrap();

jQuery('.woocommerce-LoopProduct-link').on('hover', function() {
	jQuery(this).toggleClass('on').siblings().removeClass('on');
});

// Wrap WooCommerce messages in div
jQuery('.woocommerce-message li, .woocommerce-info li, .woocommerce-error li').wrapInner(
	"<div class='woo-message-inner'></div>"
);

// Add text to the vendor dashboard link
jQuery('.woocommerce-MyAccount-content .vendor-dashboard-link').text(
	'Click here to: Upload images, view your library, view orders, manage your profile'
);
